export default () => ({
    state: false,
    close() {
        this.state = false;
    },
    init() {
        this.$watch('state', (value) => {
            if (value) {
                this.$store.body.fixed = true;
            } else {
                this.$store.body.fixed = false;
            }
        })
    }
});